import { useMemo } from "react";

import { Municipality } from "../../../../api/graphql/queries/tradeTaxDeclaration/municipalities";

export const useFormatMunicipalitiesMemo = (municipalities: Municipality[]) => {
  return useMemo(() => {
    return municipalities?.map((municipality, index) => ({
      value:
        municipality.agsKey ||
        `${municipality.name}#${municipality.taxRate}#${index}`,
      label: municipality.name,
    }));
  }, [municipalities]);
};
